import { render, staticRenderFns } from "./EditLossModal.vue?vue&type=template&id=0fbffa47&scoped=true&"
import script from "./EditLossModal.vue?vue&type=script&lang=js&"
export * from "./EditLossModal.vue?vue&type=script&lang=js&"
import style0 from "./EditLossModal.vue?vue&type=style&index=0&id=0fbffa47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbffa47",
  null
  
)

export default component.exports